import React from 'react';
import ReactPlayer from 'react-player';

const VideoPlayer = (props: any) => {
  return(
  <ReactPlayer
    data-testid="video-player"
    url={props.source} 
    playing={props.isplaying} 
    width={props.width} 
    height={props.height} 
    controls={props.controls}
  ></ReactPlayer>
  )
}

export default VideoPlayer;